import { TeamShortDto } from ".";

export class DrawingBasketDto {
    basket1: TeamShortDto[];

    basket2: TeamShortDto[];
}